import { inject, Injectable } from '@angular/core';
import { LocumsContractRequestsEvents } from '../enums/locums-contract-request-events.enum';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { ContractRequestsStore } from './contract-requests.store';

@Injectable({ providedIn: 'root' })
export class ContractRequestsReducer {
    private readonly contractRequestsStore = inject(ContractRequestsStore);
    private readonly eventBus = inject(EventBusService);

    constructor() {
        this.listenToLoadLocums1099MarginPipelineRequestsEvent();
    }

    private listenToLoadLocums1099MarginPipelineRequestsEvent() {
        this.eventBus
            .on(LocumsContractRequestsEvents.LOCUMS_CONTRACT_REQUESTS_LOAD)
            .subscribe((event: EventPayload) => {
                this.contractRequestsStore.updateMarginPipelineRequestsFromData(event.payload.pipelineRequests);
            });
    }
}
